import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import Loading from 'core-system/Loading'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from 'redux/config/store'
import styled from 'styled-components'
import ComplianceAreaCards from './components/ComplianceAreaCards'
import ComplianceStatsCard from './components/ComplianceStatsCard'
import { complianceActions } from 'redux/compliance/complianceActions'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

const emptySummary = {
  regions: 0,
  totalSites: 0,
  compliantSites: 0,
  actionNeeded: 0,
  totalEmployees: 0,
  overallComplianceRate: 0,
}

const ComplianceView = React.memo(() => {
  const dispatch = useDispatch()
  const { overview, overviewLoading } = useSelector(
    (state: AppState) => state.compliance
  )

  useEffect(() => {
    dispatch(complianceActions.getComplianceOverview())
  }, [dispatch])

  return (
    <Container>
      <Text variant='action1' color={palette.text.primary}>
        Monitor and manage compliance requirements across your worksites
      </Text>
      {overviewLoading && !overview ? (
        <Loading />
      ) : (
        <>
          <ComplianceStatsCard stats={overview?.summary || emptySummary} />
          <ComplianceAreaCards areas={overview?.areas || []} />
        </>
      )}
    </Container>
  )
})

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  ComplianceView.displayName = 'ComplianceView'
}

export default ComplianceView
